import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { HelpCenterService } from '../../../../services/helpcenter-service';
import Global from '../../../../store/global-selectors';
import { US } from '../../../../constants/country-codes';
import { messages } from '../messages';
import { submitZendeskSsoForm } from '../../../../services/zendesk-sso-service';

export const useGetHelpItem = () => {
  const homeCountry = useSelector(Global.selectSellerHomeCountry) || US;

  const handleGetHelpClicked = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      await submitZendeskSsoForm(HelpCenterService.getMainSupportUrl(homeCountry));
    },
    [homeCountry],
  );

  return useMemo(
    () => ({
      description: <FormattedMessage {...messages.supportGetHelp} />,
      testId: 'support-center-get-help-item',
      onClick: handleGetHelpClicked,
    }),
    [handleGetHelpClicked],
  );
};
